/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui'

export const useStatCardStyles = makeStyles()(theme => ({
  card: {
    padding: theme.spacing(3),
  },
  circularContainer: {
    height: 54,
    width: 54,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
